/**
 * Shared PDP helpers for part buy box (picker-aware dimensions, not product-level guesses).
 */
(function () {
  function fieldsetLegend(fieldset) {
    if (!fieldset) return "";
    var leg = fieldset.querySelector("legend");
    return leg ? leg.textContent.replace(/\s+/g, " ").trim().toLowerCase() : "";
  }

  function mmFromCheckedInputs(legendRe) {
    var inputs = document.querySelectorAll(
      'variant-picker[data-zc-avail-picker] fieldset.variant-option input[type="radio"]:checked'
    );
    for (var i = 0; i < inputs.length; i++) {
      var fs = inputs[i].closest("fieldset");
      if (fs && window.getComputedStyle(fs).display === "none") continue;
      var name = fieldsetLegend(fs);
      if (legendRe && !legendRe.test(name)) continue;
      var v = String(inputs[i].value || "").trim();
      if (/^\d+(?:\.\d+)?\s*mm$/i.test(v)) return v.replace(/\s+/g, "");
    }
    return "";
  }

  /** Bar rise only — never Travel / Wheel size / Stroke pills. */
  function barRiseMmFromPicker() {
    return mmFromCheckedInputs(/^(configuration|size|rise|bar rise)$/);
  }

  function travelMmFromPicker() {
    return mmFromCheckedInputs(/^(travel|stroke)$/);
  }

  function riseMmFromPicker() {
    return barRiseMmFromPicker();
  }

  function selectedOptionValues() {
    var values = [];
    document
      .querySelectorAll(
        'variant-picker[data-zc-avail-picker]:not([data-zc-hide-picker]) fieldset.variant-option input[type="radio"]:checked'
      )
      .forEach(function (input) {
        var fs = input.closest("fieldset");
        if (fs && window.getComputedStyle(fs).display === "none") return;
        if (input.value) values.push(String(input.value).trim());
      });
    return values;
  }

  function labelMm(raw, suffix) {
    if (!raw) return "";
    var m = String(raw).match(/(\d+(?:\.\d+)?)\s*mm/i);
    var mm = m ? m[1] + "mm" : String(raw).trim();
    if (!mm) return "";
    if (!suffix || new RegExp(suffix, "i").test(mm)) return mm;
    return mm + " " + suffix;
  }

  function isRiseHighlight(text) {
    return /^\d+(?:\.\d+)?\s*mm(?:\s+(?:bar\s+)?rise)?$/i.test(String(text || "").trim());
  }

  function isTravelHighlight(text) {
    return /^\d+(?:\.\d+)?\s*mm(?:\s+travel)?$/i.test(String(text || "").trim());
  }

  function specLine(specs, label) {
    if (!specs) return "";
    var want = String(label).toLowerCase();
    var lines = String(specs).split(/\r?\n/);
    for (var i = 0; i < lines.length; i++) {
      var t = lines[i].trim();
      var idx = t.indexOf(":");
      if (idx < 0) continue;
      if (t.slice(0, idx).trim().toLowerCase() === want) return t.slice(idx + 1).trim();
    }
    return "";
  }

  function isHandlebarProductRoot(root) {
    if (!root) return false;
    var slug = (root.getAttribute("data-part-category") || "").toLowerCase();
    var hlc = (root.getAttribute("data-part-hlc-category") || "").toLowerCase();
    var type = (root.getAttribute("data-product-type") || "").toLowerCase();
    var hay = slug + " " + hlc + " " + type;
    if (/handlebar/.test(hay)) return true;
    var diam = root.getAttribute("data-bar-diameter");
    var width = root.getAttribute("data-bar-width");
    return !!(diam && width);
  }

  window.zcPartPdpPicker = {
    fieldsetLegend: fieldsetLegend,
    barRiseMmFromPicker: barRiseMmFromPicker,
    travelMmFromPicker: travelMmFromPicker,
    riseMmFromPicker: riseMmFromPicker,
    selectedOptionValues: selectedOptionValues,
    labelMm: labelMm,
    isRiseHighlight: isRiseHighlight,
    isTravelHighlight: isTravelHighlight,
    specLine: specLine,
    isHandlebarProductRoot: isHandlebarProductRoot,
  };
})();
